import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-settings-header',
    templateUrl: './settings-header.component.html',
    styleUrls: ['./settings-header.component.scss'],
})
export class SettingsHeaderComponent {
    @Input() title: string;

    @Input() showBackButton = false;

    @Input() showCreateButton = false;

    @Input() createButtonTranslationKey = '';

    @Output() back = new EventEmitter<void>();

    @Output() create = new EventEmitter<void>();

    onBack(): void {
        this.back.emit();
    }

    onCreate(): void {
        this.create.emit();
    }
}
